import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ProductAnalyticService } from './shared/product-analytic/product-analytic';
import { ApiVersionService } from './v2/shared/api-version.service';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from './core/services/profile/profile.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class AppComponent implements OnInit {
  isNotLoading: boolean = false;
  title = 'MFG';
  private latestVersion: string | null = null;
  showVersionDisplay: boolean = false; // Control version display visibility

  constructor(private profileService: ProfileService, private router: Router, private productAnalyticService: ProductAnalyticService, private apiVersionService: ApiVersionService, private toastr: ToastrService) {
  }

  ngOnInit() {
    this.profileService.loadUserDetail().subscribe(isSuccess => {
      this.isNotLoading=true;
      if(isSuccess){
        if (AppStorageUtil.getLoogedUserType() === "Supplier") {
          this.profileService.getConfigCatQuoteAssistData().subscribe(isQuoteAssistEnabled => {
  
          });
        }
        this.version();
        console.log("will check Version now");
        this.apiVersionService.initVersionCheck();
        
      }
      window.document.getElementById("indexPageLoader").style.display = "none";
    });
  }

 

  version() {
    this.router.events.subscribe((evt) => {
      // checking loading chunk error, if exists reload the application
      window.addEventListener('error', (event) => {
        if (event.message.includes('Loading chunk')) {
          this.toastr.warning('A new release of the MFG application is available. The application will reload.', 'Warning!');
          setTimeout(() => location.reload(), 5000);
        }
      });

      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (evt instanceof NavigationEnd) {
        this.productAnalyticService.mixpanelTracking(this.productAnalyticService.MPE_PAGEVIEW, {});
      }
      window.scrollTo(0, 0);
    });
  }
  
  ngOnDestroy() {
    this.apiVersionService.stopVersionChecking();
  }
}
